<!-- eslint-disable vue/require-v-for-key -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div id="bet-detail">
    <div class="summary-header old-mode">
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(255, 200, 36)">
          Transaction
        </div>
        <div class="header-item-value">{{ roundId }}</div>
      </div>
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(255, 200, 36)">
          Bet ({{ currency }})
        </div>
        <div class="header-item-value">{{ bet, currency | currencyFormatter }}</div>
      </div>
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(255, 200, 36)">
          Profit ({{ currency }})
        </div>
        <div class="header-item-value">{{ winlose, currency | currencyFormatter }}</div>
      </div>
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(255, 200, 36)">
          Balance ({{ currency }})
        </div>
        <div class="header-item-value">{{ balance, currency | currencyFormatter }}</div>
      </div>
    </div>
    <section class="ps-container bet-details ps ps--theme_default">
      <div class="content-wrapper">
        <div v-if="freeCount.length > 1" class="result-title has-more" :style="`height:${mobile ? '45px' : '64px'}`" @click="slideDown">
          <div class="result-title-container">
            <div class="result-title-title">
              <span style="color: rgb(255, 200, 36)">{{ headerCal() }}</span>
              <div v-if="freeCount.length > 1" class="img" style="background-color: rgb(255, 200, 36);"></div>
            </div>
            <div class="result-title-detail">
              <div class="result-detail-item round-title" v-if="this.data.length > 1">
                Round {{ findIndexes() }}
              </div>
              <div class="result-detail-item">
                Bet Size {{ betDetail.betSize }}
              </div>
              <div class="result-detail-item">
                Bet Level {{ betDetail.betLevel }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="result-title" :style="`height:${mobile ? '45px' : '64px'}`">
          <div class="result-title-container">
            <div class="result-title-title">
              <span style="color: rgb(255, 200, 36)">{{ headerCal() }}</span>
            </div>
            <div class="result-title-detail">
              <div class="result-detail-item round-title" v-if="this.data.length > 1">
                Round {{ findIndexes() }}
              </div>
              <div class="result-detail-item">
                Bet Size {{ betDetail.betSize }}
              </div>
              <div class="result-detail-item">
                Bet Level {{ betDetail.betLevel }}
              </div>
            </div>
          </div>
        </div>

        <div class="bet-result-container">
          <div class="reel-container-background sprite-symbol reel_bg"></div>
          <div class="reel-bar-container">
            <div class="block" v-for="(symbols) in reelData[6]">
              <div :class="`sprite-symbol base ${symbolName(symbols, true)}_block_1x1`"></div>
              <div :class="`sprite-symbol symbol-reel ${symbolName(symbols, false)}`"></div>
            </div>
          </div>
          <div class="reel-container">
            <div :class="`block ${symbols.symbol === 11 || symbols.symbol === 12 ? 'glow' : ''}`"
              v-for="(symbols) in symbolsReel" :style="`${check(symbols)}`">
              <div :class="`sprite-symbol base ${symbolName(symbols, true)}_block_1x${symbols.size}`"
                v-if="symbols.symbol != 11 || symbols.symbol != 12" style="top: 0px; left: 0px"></div>
              <div :class="`sprite-symbol symbol-reel ${symbolName(symbols, false)}`"
                :style="`${styleSymbols(symbols)}`">
              </div>
              <div :class="`sprite-symbol frame special_1x${symbols.size}_silver`"
                v-if="symbols.symbol > 12 && symbols.symbol < 24" :style="`top: 0px; left: 0px;`"></div>
              <div :class="`sprite-symbol frame special_1x${symbols.size}_gold`" v-if="symbols.symbol >= 24"
                :style="`top: 0px; left: 0px;`"></div>
            </div>
          </div>
        </div>

        <div class="payout-list">
          <div class="payout-list-header">
            <div class="payout-header-separator"></div>
            <div class="payout-title">Payout</div>
            <div class="payout-header-separator"></div>
          </div>
          <div class="payout-list-content">
            <div class="payout-list-empty" :style="`display: ${win ? 'none' : ''}`">
              No Winning Combination
            </div>
            <div class="payout"
              :style="`${this.roundData.detail.featureBuy && state === 'SPIN' ? 'display: block' : 'display: none'}`">
              <div class="payout-item-container">
                <div class="payout-item-label">
                  <div class="payout-item-title">
                    Feature Buy
                  </div>
                  <div class="payout-item-subtitle">

                  </div>
                </div>
              </div>
            </div>
            <div class="payout">
              <div class="payout-item-container" v-if="collector_neko >= 1">
                <div class="payout-item-reward-icon">
                  <div class="sprite-symbol sprite symbol neko"></div>
                </div>
                <div class="payout-item-label">
                  <div class="payout-item-title">
                  </div>
                </div>
                <div class="payout-item-reward">
                  <div class="payout-item-reward-title">
                    +{{ collector_neko }}
                  </div>
                  <div class="payout-item-reward-subtitle">
                    Collected
                  </div>
                </div>
              </div>
              <div class="payout-item-container" v-if="collector_multiplier > 1">
                <div class="payout-item-label">
                  <div class="payout-item-title">
                    Win Multiplier x{{ multiplier }}
                  </div>
                  <div class="payout-item-subtitle"></div>
                </div>
              </div>
            </div>
            <div class="payout" :style="`display: ${win > 0 ? '' : 'none'}`" v-for="(item, i) in winnings"
              :key="item.name">
              <div class="payout-item-container">
                <div class="payout-item-reward-icon">
                  <div :class="`sprite-symbol sprite symbol ${symbolName2(item.symbol, false)}`"></div>
                </div>
                <div class="payout-item-label">
                  <div class="payout-item-title">{{ item.row }} of a Kind</div>
                  <div class="payout-item-subtitle">
                    {{ item.count }} way{{ item.count > 1 ? "(s)" : "" }}
                  </div>
                </div>
                <div class="payout-item-reward with-tooltip">
                  <div class="payout-item-reward-title">
                    {{ currency }} {{ item.amount, currency | currencyFormatter }}
                  </div>
                  <div class="payout-item-reward-subtitle">
                    {{ currency }} {{ (item.amount / multiplier), currency | currencyFormatter }} x
                    {{ multiplier }}
                  </div>
                  <div id="payout-item-reward-tooltip-itm0" class="payout-item-reward-tooltip" @click="submit(i)"></div>
                </div>
                <div :class="`payout-item-popup-box content${i}`" v-if="isOn && i === hint">
                  <div class="payout-item-popup-container">
                    <div class="payout-item-popup">
                      <div class="payout-item-popup-title">
                        Bet Size x Bet Level x Symbol Payout Values x Way(s) x
                        Multiplier
                      </div>
                      <div class="payout-item-popup-subtitle">
                        {{ betDetail.betSize }} <span>x</span>
                        {{ betDetail.betLevel }} <span>x</span>
                        {{
                          Math.round(
                            item.amount /
                            (betDetail.betSize *
                              betDetail.betLevel *
                              item.count *
                              multiplier)
                          )
                        }}
                        <span>x</span> {{ item.count }} <span>x</span>
                        {{ multiplier }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="payout freespin" :style="`display: ${freespins > 0 ? '' : 'none'}`">
              <div class="payout-item-container">
                <div class="payout-item-reward-icon">
                  <div :class="`sprite-symbol sprite symbol scatter_en`"></div>
                </div>
                <div class="payout-item-label">
                  <div class="payout-item-title">X{{ scatterCount }}</div>
                  <div class="payout-item-subtitle"></div>
                </div>
                <div class="payout-item-reward with-tooltip">
                  <div class="payout-item-reward-title">
                    {{ freespins }} Free Spins
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bet-result-list" style="display: none;">
          <div class="result-list-view">
            <section class="ps-container result-list-content ps ps--theme_default"
              data-ps-id="27cb5135-a5f3-f06b-faa5-a770532fdbff">
              <div class="ps__scrollbar-x-rail" style="left: 0px; bottom: 0px;">
                <div class="ps__scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
              </div>
              <div class="ps__scrollbar-y-rail" style="top: 0px; right: 0px;">
                <div class="ps__scrollbar-y" tabindex="0" style="top: 0px; height: 0px;"></div>
              </div>
              <div v-for="(item, index) in roundList" :key="index" @click="goToIndex(item.page)" class="bet-result-item"
                :id="`round-${index}`">
                <div v-if="item.detail.state === 'SPIN'" class="result-item-name">
                  Normal Spin
                </div>
                <div v-else class="result-item-name">
                  Free Spin: {{ index }}/{{ freeCount.length }}
                </div>
                <div class="result-item-win">
                  {{ item.winlose < 0 ? '-' : '' }}{{ currency }} {{ Math.abs(item.winlose), currency |
                    currencyFormatter }} </div>
                </div>
            </section>
          </div>
          <div class="result-list-bg"></div> <a href="javascript:void(0);" class="result-list-close"
            @click="slideUp">Close</a>
        </div>
      </div>
    </section>
    <div>
      <a class="detail-navigation left" :style="isPrev" @click="prevTran" id="clickLeft">
        <div class="img back" style="background-color: rgb(255, 200, 36)"></div>
      </a>
      <a class="detail-navigation right" :style="isNext" @click="nextTran" id="clickRight">
        <div class="img next" style="background-color: rgb(255, 200, 36)"></div>
      </a>
    </div>
    <div class="version">1.4.2.23</div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-aztec",
  props: {
    data: Array,
    tranID: String,
    mobile: String,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      date: "",
      time: "",
      currency: "",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      state: "SPIN",
      multiplier: 0,
      reels: [],
      winnings: [],
      isOn: false,
      hint: 0,
      bet: 0,
      tranId: "",
      roundData: null,
      index: 0,
      isNext: "",
      isPrev: "",
      normalMultiplier: [1, 2, 3, 5],
      freespinMultiplier: [2, 4, 6, 10],
      freespins: 0,
      scatterCount: 0,
      collector_multiplier: 0,
      collector_neko: 0,
      isEndRound: false,
      round: 0,
      spinRound: 0,
      betDetail: {
        betSize: 0,
        betLevel: 0,
        baseBet: 0,
      },
      freeCount: [],
      spinCount: [],
      symbolsReel: [],
      roundList: [],
    };
  },
  async created() {
    await this.mapSymbol(this.tranID);
    this.mapSpin();
    this.mapRoundList();
  },
  methods: {
    async mapSymbol(tranId) {
      if (tranId) {
        let index = this.data.findIndex((round) => round.tranId === tranId);
        this.index = index;
        this.roundData = this.data[index];
        this.tranId = tranId;
      } else {
        this.roundData = this.data[0];
        this.index = 0;
        this.tranId = this.roundData.tranId;
      }
      let buttonStyle = this.mobile ? `35px` : `10px`;
      this.isNext =
        this.index === this.data.length - 1
          ? `display:none !important`
          : `right: ${buttonStyle}`;
      this.isPrev =
        this.index === 0 ? `display:none !important` : `left: ${buttonStyle}`;

      this.bet = this.roundData.betAmount;
      this.getBetSize();
      this.roundId = String(this.roundData.tranId).split("-")[0];
      this.isEndRound = this.roundData.detail.isEndRound;
      this.winlose = this.roundData.winlose;
      this.balance = this.roundData.balance.after;
      this.state = this.roundData.detail.state;
      this.nextState = this.roundData.detail.nextState;
      this.reels = this.roundData.detail.reels;
      this.reelSizes = this.roundData.detail.reelSizes;
      this.reelData = this.sortData();
      this.win = this.roundData.detail.win;
      this.multiplier = this.roundData.detail.multiplier;
      this.currency = utils.getCurrencySign(this.roundData.currency);
      this.isOn = false;
      this.freespins = 0;
      this.scatterCount = await this.freeSpinCheck(this.roundData);
      this.collector_multiplier = this.roundData.detail.multiplier;
      this.collector_neko = await this.collector_neko_func(this.roundData.detail);
      if (this.scatterCount >= 4 && this.nextState === "FREESPIN") {
        this.freespins =
          this.roundData.detail.freeSpin.retrigger > 0
            ? this.roundData.detail.freeSpin.retrigger
            : this.roundData.detail.freeSpin.remain;
      }
      if (this.roundData.detail.winnings === undefined) this.winnings = [];
      else this.winnings = this.roundData.detail.winnings;
      this.round =
        this.state === "SPIN" || this.state === "RESPIN"
          ? this.roundData.detail.round
          : this.roundData.detail.freeSpin.round;
      this.spinRound = this.roundData.detail.spinRound;
      this.symbolsReel = await this.newReelsData();
    },
    async newReelsData() {
      let data = [];
      return new Promise((resolve) => {
        for (let i = 0; i < this.reelSizes.length - 1; i++) {
          for (let j = 0; j < this.reelSizes[i].length; j++) {
            let index = 0;
            if (j > 0) index = this.reelSizes[i].filter((size, index) => index < j).reduce((a, b) => a + b);
            data.push({
              reel: i,
              symbol: this.reels[i][j],
              size: this.reelSizes[i][j],
              index: index
            })
            if ((i === this.reelSizes.length - 2) && (j === this.reelSizes[i].length - 1)) {
              resolve(data);
            }
          }
        }
      })
    },
    async getBetSize() {
      this.betDetail.betSize = this.roundData.detail.betSize;
      this.betDetail.betLevel = this.roundData.detail.betLevel;
      this.betDetail.baseBet = this.roundData.detail.baseBet;
    },
    async submit(num) {
      this.hint = num;
      this.isOn = !this.isOn;
    },
    async nextTran() {
      if (this.index < this.data.length - 1) {
        this.index++;
        this.mapSymbol(this.data[this.index].tranId);
      }
    },
    async prevTran() {
      if (this.index > 0) {
        this.index--;
        this.mapSymbol(this.data[this.index].tranId);
      }
    },
    async goToIndex(index) {
      this.index = index;
      this.mapSymbol(this.data[index].tranId);
      this.slideUp();
    },
    async slideDown() {
      let iPage = this.roundList.findIndex((round) => round.page > this.index);
      if (iPage === -1) iPage = this.roundList.length - 1;
      else iPage = iPage - 1;
      const target = document.getElementsByClassName(`bet-result-item`);
      for (let i = 0; i < target.length; i++) {
        target[i].classList.remove("active");
        target[i].getElementsByClassName('result-item-name')[0].style = "";
        target[i].getElementsByClassName('result-item-win')[0].style = "";

        if (i === iPage) {
          target[i].classList.add("active");
          target[i].getElementsByClassName('result-item-name')[0].style = "color: rgb(255, 200, 36);"
          target[i].getElementsByClassName('result-item-win')[0].style = "color: rgb(255, 200, 36);"
        }
      }

      const list = document.getElementsByClassName("bet-result-list")[0];
      list.style.display = "block";
      list.classList.remove("slide-fade-leave-active", "slide-fade-leave-to");
      list.classList.add("slide-fade-enter", "slide-fade-enter-active");

      void list.offsetHeight; // force reflow
      list.classList.remove("slide-fade-enter");

      setTimeout(() => {
        list.classList.remove("slide-fade-enter-active");
      }, 300);
    },

    async slideUp() {
      const list = document.getElementsByClassName("bet-result-list")[0];
      list.classList.add("slide-fade-leave-active", "slide-fade-leave-to");

      setTimeout(() => {
        list.classList.remove("slide-fade-leave-active", "slide-fade-leave-to");
        list.style.display = "none";
      }, 300);
    },
    async freeSpinCheck(roundData) {
      let scatterCount = 0;
      roundData.detail.reels.forEach((reel) => {
        reel.forEach((item) => {
          if (item === 11) scatterCount++;
        });
      });
      return scatterCount;
    },
    async collector_neko_func(_param) {
      let b = _param.multiplier / 2;
      let c = (_param.multiplier - 2) / 2;
      switch (_param.state) {
        case "SPIN": return b;
        case "RESPIN": return b;
        case "FREESPIN": return c;
        case "FREERESPIN": return c;
        case "-": return c;
        default: return _param.multiplier;
      }
    },
    symbolName2(index) {
      let symbolId = index;
      if (index < 11) symbolId = index;
      else if (index >= 11 && index < 13) symbolId = index
      else if (index >= 13 && index < 24) symbolId = index - 13;
      else symbolId = index - 24;

      switch (symbolId) {
        case 0: return 'l_10';
        case 1: return 'l_j';
        case 2: return 'l_q';
        case 3: return 'l_k';
        case 4: return 'l_a';
        case 5: return 'sushi';
        case 6: return 'f_sushi';
        case 7: return 'fan';
        case 8: return 'lantern';
        case 9: return 'drum';
        case 10: return 'neko';
        case 11: return 'scatter_en';
        case 12: return 'wild_en_1x1';
        default: '';
      }
    },
    symbolName(symbol, isBg) {
      let symbolId = symbol.symbol;
      if (symbol.symbol < 11) symbolId = symbol.symbol;
      else if (symbol.symbol >= 11 && symbol.symbol < 13) symbolId = symbol.symbol
      else if (symbol.symbol >= 13 && symbol.symbol < 24) symbolId = symbol.symbol - 13;
      else symbolId = symbol.symbol - 24;

      let name = '';
      switch (symbolId) {
        case 0: name = 'l_10';
          break;
        case 1: name = 'l_j';
          break;
        case 2: name = 'l_q';
          break;
        case 3: name = 'l_k';
          break;
        case 4: name = 'l_a';
          break;
        case 5: name = 'sushi';
          break;
        case 6: name = 'f_sushi';
          break;
        case 7: name = 'fan';
          break;
        case 8: name = 'lantern';
          break;
        case 9: name = 'drum';
          break;
        case 10: name = 'neko';
          break;
        case 11: name = symbol.size > 1 ? "scatter_b_en" : `scatter_en`;
          break;
        case 12: name = `wild_en_1x${symbol.size}`;
          break;
        default: '';
          break;
      }

      if (!isBg) {
        if ((symbolId > 4 && symbolId != 11 && symbolId != 12) && symbol.size > 1) return name + '_b';
        else return name;
      } else return name;
    },
    sortData() {
      let newData = [];
      this.reelSizes.forEach((reelSize, reelIndex) => {
        let reel = [];
        reelSize.forEach((size, index) => {
          let data = {};
          if (size > 1) {
            for (let i = 1; i <= size; i++) {
              if (i === 1) {
                let dataA = {}
                dataA['symbol'] = this.reels[reelIndex][index];
                dataA['size'] = size;
                dataA['combine'] = false;
                reel.push(dataA);
              }
              else {
                let dataB = {}
                dataB['symbol'] = this.reels[reelIndex][index];
                dataB['size'] = size;
                dataB['combine'] = true;
                reel.push(dataB);
              }
            }
          }
          else {
            data['symbol'] = this.reels[reelIndex][index];
            data['size'] = size;
            data['combine'] = false;
            reel.push(data);
          }
        })
        newData.push(reel);
      })
      return newData;
    },
    iconHeight(size) {
      switch (size) {
        case 1: return 0;
        case 2: return 21;
        case 3: return 42;
        case 4: return 61;
      }
    },
    frameName(id) {
      if (id >= 13 && id < 24) return 's_silver_frame';
      else if (id >= 24) return 's_gold_frame';
      else '';
    },
    headerCal() {
      if (this.state === 'SPIN' || this.state === 'RESPIN') {
        return 'Normal Spin'
      } else {
        return `Free Spin: ${this.round}/${this.roundData.detail.freeSpin.remain}`
      }
    },
    mapSpin() {
      let spin = [];
      let freespin = [];
      this.data.forEach(data => {
        if (data.detail.state === 'SPIN' || data.detail.state === 'RESPIN') {
          spin.push(data)
        } else {
          if (freespin[data.detail.freeSpin.round - 1]) freespin[data.detail.freeSpin.round - 1].push(data)
          else freespin[data.detail.freeSpin.round - 1] = [data];
        }
      })
      this.spinCount = spin;
      this.freeCount = freespin;
    },
    mapRoundList() {
      let arrangeList = [];
      let win = 0;
      this.spinCount.forEach((spin) => {
        win += spin.winlose;
      })
      let a1 = {
        detail: this.spinCount[0].detail,
        winlose: win,
        round: this.spinCount[0].tranId,
        page: this.findPageIndex(this.spinCount[0].tranId),
      }
      arrangeList.push(a1);
      this.freeCount.forEach((round) => {
        win = 0;
        round.forEach((data) => {
          win += data.winlose;
        })
        let a2 = {
          detail: round[0].detail,
          winlose: win,
          round: round[0].tranId,
          page: this.findPageIndex(round[0].tranId),
        }
        arrangeList.push(a2);
      })

      this.roundList = arrangeList;
    },
    findPageIndex(tranId) {
      let index = this.data.findIndex((round) => round.tranId === tranId);
      return index;
    },
    findIndexes() {
      let a = document.getElementsByClassName("round-title");
      if (this.roundData.detail.state === 'FREESPIN' || this.roundData.detail.state === 'FREERESPIN') {
        let text = '';
        this.freeCount.forEach((count) => {
          count.forEach((data, j) => {
            if (data === this.roundData) {
              text = `${j + 1}/${count.length}`;
            }
          })
        })
        if (text === '1/1') {
          if (a[0]) a[0].style = 'display: none';
        }
        else {
          if (a[0]) a[0].style = 'display: block; color: rgb(255, 200, 36);';
        }
        return text;
      } else {
        let text = '';
        this.spinCount.forEach((count, i) => {
          if (count === this.roundData) {
            text = `${i + 1}/${this.spinCount.length}`;
          }
        })
        if (text === '1/1') {
          if (a[0]) a[0].style = 'display: none';
        }
        else {
          if (a[0]) a[0].style = 'display: block; color: rgb(255, 200, 36);';
        }
        return text;
      }
    },
    check(symbol) {
      return `width: 53px; height: ${symbol.size * 43}px; top: ${symbol.index * 42}px; left: ${symbol.reel * 50}px`;
    },
    styleSymbols(symbol) {
      let symbolId = symbol.symbol;
      if (symbol.symbol < 11) symbolId = symbol.symbol;
      else if (symbol.symbol >= 11 && symbol.symbol < 13) symbolId = symbol.symbol
      else if (symbol.symbol >= 13 && symbol.symbol < 24) symbolId = symbol.symbol - 13;
      else symbolId = symbol.symbol - 24;

      if (symbolId == 11) {
        if (symbol.size == 1) return `top: -10px; left: -5px;`;
        else if (symbol.size == 2) return `top: -10px; left: -5px;margin-top: 8px;`;
        else if (symbol.size == 3) return `top: 50%; left: -5px; margin-top: -69px;`;
      }
      else if (symbolId == 12) {
        if (symbol.size == 1) return `top: -10px; left: -5px;`;
        else if (symbol.size == 2) return `top: -10px; left: -5px;; margin-top: 6px;`;
        else if (symbol.size == 3) return `top: 50%; left: -5px; margin-top: -64px;`;
        else if (symbol.size == 4) return `top: 50%; left: -5px; margin-top: -93px;`;
      }
      else {
        if (symbol.size == 1) return `top: 0px; left: 0px;`;
        else if (symbol.size > 1) {
          if (symbolId > 4) return `top: 50%; left: 0px; margin-top: -42px;`;
          else return `top: 50%; left: 0px; margin-top: -21px;`;
        }
        else if (symbol.size > 2) return `top: 50%; left: 0px; margin-top: -42px;`;
      }
    }
  },
};
</script>

<style scoped>
body {
  font-family: "PingFang,PingFangSC-Light,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif";
  background-color: #292933;
  margin: 0;
}

.version {
  bottom: 0;
  right: 5px;
  line-height: 20px;
  font-size: 10px;
  padding: 2px;
  color: #888
}

.debug,
.version {
  position: absolute
}

.detail-navigation {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  top: 280px;
  background-color: #282832;
  transition: .2s ease-in-out;
  z-index: 10
}

.detail-navigation:active {
  opacity: .2
}

.detail-navigation .img {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 18px
}

.detail-navigation .img.back {
  -webkit-mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACR3daqQRAAAAaklEQVQoz7XSSw5AMBSF4aO1CzNN7FLEGiyCdRmIXfwmJMVVnfSOv+Tcl3QrhKioERMLwiGZxCMGNjoDRWRkJyCckqRFeIQoQpQkJ3N5pGelsclzyO+K4sJ3XGbjfysozqwDZ77K6+nmCx1JkuAzXzjJvQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0xMlQwMDowOToyOS0wNDowMPuRAYoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMTJUMDA6MDk6MjktMDQ6MDCKzLk2AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==);
  mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACR3daqQRAAAAaklEQVQoz7XSSw5AMBSF4aO1CzNN7FLEGiyCdRmIXfwmJMVVnfSOv+Tcl3QrhKioERMLwiGZxCMGNjoDRWRkJyCckqRFeIQoQpQkJ3N5pGelsclzyO+K4sJ3XGbjfysozqwDZ77K6+nmCx1JkuAzXzjJvQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0xMlQwMDowOToyOS0wNDowMPuRAYoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMTJUMDA6MDk6MjktMDQ6MDCKzLk2AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==)
}

.detail-navigation .img.next {
  -webkit-mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACCyVr5VqAAAAd0lEQVQoz8XSvQ0CMQyG4S/JFHQp2POkU0D0sMPdXPeTMXgpQgogjmgQdvvItmxLQnjEzA0RcAh9xBMd2Th3mAqLZC4Go2T4P9M3zLeXUdmBhaEyLzvu6taJZFKj3QvZSY3Bm8T9gLwd+GTvurzKymhXKWjiapEH5tLhN6OeCjgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDctMTJUMDA6MDg6NDQtMDQ6MDCz6wLzAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA3LTEyVDAwOjA4OjQ0LTA0OjAwwra6TwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=);
  mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACCyVr5VqAAAAd0lEQVQoz8XSvQ0CMQyG4S/JFHQp2POkU0D0sMPdXPeTMXgpQgogjmgQdvvItmxLQnjEzA0RcAh9xBMd2Th3mAqLZC4Go2T4P9M3zLeXUdmBhaEyLzvu6taJZFKj3QvZSY3Bm8T9gLwd+GTvurzKymhXKWjiapEH5tLhN6OeCjgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDctMTJUMDA6MDg6NDQtMDQ6MDCz6wLzAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA3LTEyVDAwOjA4OjQ0LTA0OjAwwra6TwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=)
}

.detail-navigation.left {
  left: 10px
}

.detail-navigation.right {
  right: 10px
}

.summary-header {
  background-color: #282834;
  height: 64px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-top: 1px solid #30303c;
  border-bottom: 1px solid #30303c
}

.summary-header .header-item {
  text-align: center;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding: 0 5px
}

.summary-header .header-item .header-item-value {
  line-height: 16px;
  margin-bottom: 2px
}

.summary-header .header-item .header-item-desc {
  font-size: 11px;
  line-height: 12px
}

.result-title {
  height: 64px;
  margin-bottom: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.result-title.has-more {
  cursor: pointer
}

.result-title.has-more .result-title-container .result-title-title span {
  margin-right: 10px
}

.result-title .result-title-container {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1
}

.result-title .result-title-container .result-title-title {
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-bottom: 5px;
  line-height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.result-title .result-title-container .result-title-title .img {
  width: 18px;
  height: 18px;
  -webkit-mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACEAAAAhABN2rDKQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACrSURBVDiN7c87CsJAEAbgfxbEQ4jVDgbSWiha6TW8j4KQS1gKtpbaJRO1thCxFA+hjoUPEDS7mzp/OY+PGaCKVzSz/dK7qe0BgNEl10G0ULHTYCTnBIbmumvXnoVtFKnYs+aceCPCExW+qHD83QjAVHj8EwnBnIgP5o0UYS6ECl6IAawAnb1GR6D7gDqnQxD0vgy36xogA2BI3ePe/c8/bGObmrYapYEqnzwAZeprKUNxk74AAAAASUVORK5CYII=);
  mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACEAAAAhABN2rDKQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACrSURBVDiN7c87CsJAEAbgfxbEQ4jVDgbSWiha6TW8j4KQS1gKtpbaJRO1thCxFA+hjoUPEDS7mzp/OY+PGaCKVzSz/dK7qe0BgNEl10G0ULHTYCTnBIbmumvXnoVtFKnYs+aceCPCExW+qHD83QjAVHj8EwnBnIgP5o0UYS6ECl6IAawAnb1GR6D7gDqnQxD0vgy36xogA2BI3ePe/c8/bGObmrYapYEqnzwAZeprKUNxk74AAAAASUVORK5CYII=)
}

.result-title .result-title-container .result-title-detail {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.result-title .result-title-container .result-title-detail .result-detail-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 0 12px;
  font-size: 11px;
  color: hsla(0, 0%, 100%, .25)
}

.result-title .result-title-container .result-title-detail .result-detail-item:first-child {
  text-align: right
}

.result-title .result-title-container .result-title-detail .result-detail-item:not(:last-child) {
  border-right: 1px solid #000
}

.bet-result {
  padding: 10px;
  margin: 0 auto
}

.bet-result .bet-result-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.bet-result .bet-result-row:not(:last-child) {
  margin-bottom: 5px
}

.bet-result .bet-result-row .bet-result-col:not(:last-child) {
  margin-right: 2px
}

.bet-result-outline-border {
  position: absolute;
  display: block;
  width: 280px;
  height: 260px;
  top: 0;
  left: 50%;
  margin-left: -140px;
  z-index: 3
}

.bet-result-outline-border .bet-result-outline-border-container {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 280px;
  height: 260px;
  padding: 0 !important
}

.bet-result-outline-border .bet-result-outline-border-container .bet-result-column {
  position: relative
}

.bet-result-outline-border .bet-result-outline-border-container .bet-result-column .bet-result-tile-container {
  position: relative;
  width: 54px;
  height: 50px
}

.bet-result-outline-border .bet-result-outline-border-container .bet-result-column .bet-result-tile-container .outlineborder-item {
  position: absolute
}

.payout-list .payout-list-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 12px;
  height: 12px;
  padding: 0 32px;
  margin-bottom: 14px
}

.payout-list .payout-list-header .payout-header-separator {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1px;
  background-color: #282834
}

.payout-list .payout-list-header .payout-title {
  color: hsla(0, 0%, 100%, .3);
  font-size: 11px;
  padding: 0 20px
}

.payout-list .payout-list-content {
  padding: 0 80px
}

.payout-list .payout-list-content .payout-list-empty {
  padding: 20px 0;
  text-align: center
}

.payout-item-container {
  height: 56px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative
}

.payout-item-container.only-title {
  height: 42px !important
}

.payout-item-container .payout-item-label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1
}

.payout-item-container .payout-item-label .payout-item-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  line-height: 16px;
  letter-spacing: 0;
  margin-bottom: 2px;
  word-break: break-word
}

.payout-item-container .payout-item-label .payout-item-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, .3);
  line-height: 12px;
  letter-spacing: 0;
  word-break: break-word
}

.payout-item-container .payout-item-reward {
  height: auto;
  padding-left: 4px;
  position: relative
}

.payout-item-container .payout-item-reward.with-icon {
  height: 100%
}

.payout-item-container .payout-item-reward.with-tooltip {
  padding-right: 20px
}

.payout-item-container .payout-item-reward .payout-item-reward-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: right;
  word-break: break-word
}

.payout-item-container .payout-item-reward .payout-item-reward-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, .3);
  line-height: 12px;
  letter-spacing: 0;
  text-align: right;
  word-break: break-word
}

.payout-item-container .payout-item-reward .payout-item-reward-tooltip {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -8px;
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAo0lEQVR4AWLwySwElE43JhSDMBCAN3CMzqP8uocDvAle5+gGTuMEDnE94YBAJQQsfFAsnDGmR7aLABIValIohQIAVJrU6S9da9UNAPDQeq5N8EWDnm2Adh4q1TsabCX2w7Q7a/23bCqZlGxAph7tvHpSbECje727FYga244D/CP4ATrCeRM/14jANQ6q3iANZ5CgQQqP8i2BUf6WmqlJ9n6mIy9UKPbc28J/cgAAAABJRU5ErkJggg==);
  width: 16px;
  height: 16px;
  opacity: .5;
  cursor: pointer
}

.payout-item-container .payout-item-reward>.payout-item-reward-righticon {
  width: 48px;
  height: 100%;
  margin-right: 0;
  margin-left: 10px;
  text-align: center;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.payout-item-container .payout-item-reward>.payout-item-reward-righticon>.sprite {
  position: absolute
}

.payout-item-container .payout-item-reward>.payout-item-reward-righticon>.bg {
  z-index: 1
}

.payout-item-container .payout-item-reward>.payout-item-reward-righticon>.symbol {
  z-index: 2
}

.payout-item-container .payout-item-reward>.payout-item-reward-righticon>.ingot {
  z-index: 3
}

.payout-item-container .payout-item-reward>.payout-item-reward-righticon.empty {
  width: 0;
  margin-right: 0;
  margin-left: 0
}

.payout-item-container .payout-item-reward-icon {
  width: 48px;
  height: 100%;
  margin-right: 10px;
  text-align: center;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.payout-item-container .payout-item-reward-icon>.sprite {
  position: absolute
}

.payout-item-container .payout-item-reward-icon>.bg {
  z-index: 1
}

.payout-item-container .payout-item-reward-icon>.symbol {
  z-index: 2
}

.payout-item-container .payout-item-reward-icon>.ingot {
  z-index: 3
}

.payout-item-container .payout-item-reward-icon.empty {
  width: 0;
  margin-right: 0
}

.payout-item-container>.payout-item-popup-box {
  position: absolute;
  height: 1px;
  width: 100%;
  bottom: 5px;
  right: 0;
  z-index: 6
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container {
  position: relative;
  width: 100%;
  top: 0;
  left: 0
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup {
  position: absolute;
  top: 0;
  background-color: #464653;
  color: #fff;
  border-radius: 6px;
  padding: 8px;
  width: 100%;
  z-index: 6
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup:after {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 30px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #464653
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-title {
  font-size: 12px;
  color: hsla(0, 0%, 100%, .3);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: left;
  word-break: break-word
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-subtitle {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-subtitle>span {
  color: hsla(0, 0%, 100%, .3)
}

.bet-payout-item .payout-item-container {
  position: relative
}

.bet-payout-item .payout-item-container>.payout-item-popup-box {
  position: absolute;
  height: 1px;
  width: 100%;
  bottom: 5px;
  right: 0;
  z-index: 6
}

.bet-payout-item .payout-item-container>.payout-item-popup-box>.payout-item-popup-container {
  position: relative;
  width: 100%;
  top: 0;
  left: 0
}

.bet-payout-item .payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup {
  position: absolute;
  top: 0;
  background-color: #464653;
  color: #fff;
  border-radius: 6px;
  padding: 8px;
  width: 100%;
  z-index: 6
}

.bet-payout-item .payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup:after {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 30px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #464653
}

.bet-payout-item .payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-title {
  font-size: 12px;
  color: hsla(0, 0%, 100%, .3);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: left;
  word-break: break-word
}

.bet-payout-item .payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-subtitle {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word
}

.bet-payout-item .payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-subtitle>span {
  color: hsla(0, 0%, 100%, .3)
}

.bet-payout-item .payout-pattern-name {
  width: 25px
}

.bet-payout-item .payout-win-display.with-tooltip {
  padding-right: 20px;
  position: relative
}

.bet-payout-item .payout-win-display>.payout-win-result {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  letter-spacing: 0;
  line-height: 16px;
  text-align: right;
  word-break: break-word
}

.bet-payout-item .payout-win-display>.payout-win-detail {
  font-size: 11px;
  color: hsla(0, 0%, 100%, .3);
  line-height: 14px;
  letter-spacing: 0;
  word-break: break-word
}

.bet-payout-item .payout-win-display .payout-item-reward-tooltip {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -8px;
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAo0lEQVR4AWLwySwElE43JhSDMBCAN3CMzqP8uocDvAle5+gGTuMEDnE94YBAJQQsfFAsnDGmR7aLABIValIohQIAVJrU6S9da9UNAPDQeq5N8EWDnm2Adh4q1TsabCX2w7Q7a/23bCqZlGxAph7tvHpSbECje727FYga244D/CP4ATrCeRM/14jANQ6q3iANZ5CgQQqP8i2BUf6WmqlJ9n6mIy9UKPbc28J/cgAAAABJRU5ErkJggg==);
  width: 16px;
  height: 16px;
  opacity: .5;
  cursor: pointer
}

.payout-line-item {
  width: 48px;
  shape-rendering: crispedges
}

.payout-line-item svg {
  display: block;
  height: 100%
}

.lines-wrapper {
  fill: transparent;
  stroke-width: 3
}

.bet-payout-item .payout-item-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 56px;
  margin: 0 auto;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.bet-payout-item .payout-pattern-name {
  margin-right: 10px
}

.bet-payout-item .payout-pattern-display {
  height: 32px
}

.bet-payout-item .payout-win-display {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right
}

.bet-result-list {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #282834;
  z-index: 20
}

.bet-result-list .result-list-view {
  height: 624px;
  padding: 8px 0;
  overflow-y: scroll
}

.bet-result-list .result-list-close {
  display: block;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-size: 16px;
  color: hsla(0, 0%, 100%, .6);
  text-decoration: none;
  transition: .2s ease-in-out;
  border-top: 1px solid #30303c;
  border-bottom: 1px solid #30303c
}

.bet-result-list .result-list-close:active {
  opacity: .4
}

.bet-result-item.active {
  cursor: auto;
  pointer-events: none;
}

.bet-result-item:nth-child(odd) {
  background-color: #282834
}

.bet-result-item:active:not(.active) {
  opacity: .6
}

.loading {
  z-index: 100;
  width: 415px;
  height: 736px;
  position: fixed;
  top: 0;
  background-color: #30303c;
  text-align: center;
  font-size: 13px;
  opacity: 1;
  color: #ffc824
}

.loading div {
  width: 100px;
  height: 100px;
  background: #282834;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 280px auto 0;
  border-radius: 5px;
  padding: 15px;
  line-height: 16px
}

.debug {
  position: absolute;
  top: 0;
  left: 0;
  padding: 12px
}

.debug,
.debug>.head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

.debug>.head {
  font-size: 12px;
  padding: 0 8px;
  width: 100%;
  overflow: hidden;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.debug>.head>div {
  float: left
}

.debug>.head>div button {
  cursor: pointer;
  font-size: 12px
}

.debug>.head .dot {
  margin: 0 0 0 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.debug>.head .dot>div {
  float: left
}

.debug>.head .dot>.dot2 {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin: 0 5px 0 3px
}

.debug>.language {
  margin-left: 12px
}

.debug>.language>.toggle {
  border: 1px solid #eee;
  width: 52px;
  padding: 4px;
  border-radius: 4px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  overflow: hidden
}

.debug>.language>.toggle>.bg {
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  background: #5d9df4;
  z-index: 1
}

.debug>.language>.toggle>.text {
  position: relative;
  z-index: 2;
  font-size: 11px;
  cursor: pointer
}

.debug>.inputdata {
  position: fixed;
  background: rgba(0, 0, 0, .7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 999
}

.debug>.inputdata>div {
  width: 50%;
  margin: 0 0 3%;
  overflow: hidden
}

.debug>.inputdata>div>textarea {
  width: 100%;
  height: 100%;
  border: none;
  overflow: auto;
  outline: none;
  word-break: break-all;
  font-size: 13px
}

.debug>.inputdata>div>div {
  margin: 2px 0 5px;
  color: #fff
}

.debug>.inputdata>div>div>button {
  width: 70px;
  font-size: 13px;
  margin: 1px 1px 0 0;
  padding: 3px 8px;
  cursor: pointer
}

.debug>.inputdata>div>div>.close {
  float: right;
  font-size: 13px;
  cursor: pointer
}

.debug>.inputdata>div>div.sample {
  font-size: 11px;
  color: #999;
  word-break: break-all;
  white-space: nowrap;
  line-height: 15px
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0
}

input {
  width: 50px;
  padding: 3px 2px;
  outline: none;
  border: 1px solid #ddd;
  font-size: 12px;
  text-align: center
}

input.long {
  width: 100px
}

input:focus,
input:hover {
  border: 1px solid #666
}

input:disabled {
  background: #ddd;
  pointer-events: none
}

.button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 4px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ddd;
  transition: all .2s;
  cursor: pointer
}

.button:disabled {
  background: #ddd;
  pointer-events: none
}

.button:focus,
.button:hover {
  border-color: #666
}

.editor {
  font-size: 12px;
  z-index: 101;
  color: #222;
  position: relative
}

.editor.mostTop {
  z-index: 103
}

.editor>.container {
  position: absolute;
  top: 44px
}

.editor>.container.left {
  left: 20px
}

.editor>.container.right {
  right: 20px
}

.editor>.container.right>.section {
  width: 360px
}

.editor>.container>.section {
  width: 300px;
  background: #fff;
  overflow: hidden;
  padding: 8px 12px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 2px
}

.editor>.container>.section.title-only>.title {
  margin: 0
}

.editor>.container>.section.key>.input>span>span {
  display: inline-block;
  color: #666;
  cursor: pointer
}

.editor>.container>.section.key>.input>span>span.active {
  color: #74cba8
}

.editor>.container>.section.key>.input>span>span:first-child {
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg)
}

.editor>.container>.section.key>.input>span>span:nth-child(2) {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg)
}

.editor>.container>.section.styles>.config {
  margin-bottom: 4px;
  position: relative
}

.editor>.container>.section.styles>.config,
.editor>.container>.section.styles>.config>div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.editor>.container>.section.styles>.config>div {
  width: calc(50% - 6px)
}

.editor>.container>.section.styles>.config>input {
  width: 100px;
  transition: all .2s
}

.editor>.container>.section.styles>.config>.delete {
  position: absolute;
  top: calc(50% - 11px);
  right: -22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: #e2252b;
  opacity: 0;
  transition: all .2s;
  cursor: pointer
}

.editor>.container>.section.styles>.config:hover>.delete,
.editor>.container>.section.styles>.config:hover>input {
  -webkit-transform: translateX(-22px);
  transform: translateX(-22px)
}

.editor>.container>.section.styles>.config:hover>.delete {
  opacity: 1
}

.editor>.container>.section.styles>.header {
  margin-top: 14px;
  margin-bottom: 6px
}

.editor>.container>.section>.title {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 4px 0 8px
}

.editor>.container>.section>.title,
.editor>.container>.section>.title>span {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.editor>.container>.section>.title>span {
  font-size: 13px;
  font-weight: 700
}

.editor>.container>.section>.title>span>.hint {
  font-weight: 400;
  font-size: 10px;
  color: #666;
  padding-left: 4px
}

.editor>.container>.section>.title>.act {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #666;
  color: #fff;
  border-radius: 2px;
  padding: 5px 6px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 12px;
  transition: all .2s
}

.editor>.container>.section>.title>.act.active {
  background: #f5c831;
  color: #222
}

.editor>.container>.section>.title>.act:hover {
  opacity: .7
}

.editor>.container>.section>.title>.act[disabled=disabled] {
  background: #222;
  pointer-events: none
}

.editor>.container>.section>.list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 4px
}

.editor>.container>.section>.list>div {
  padding: 6px 8px;
  background: #fff;
  color: #222;
  margin: 4px;
  border: 1px solid #ddd;
  border-radius: 2px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
  transition: all .2s
}

.editor>.container>.section>.list>div:hover {
  border: 1px solid #222
}

.editor>.container>.section>.list>div:active {
  background: #f9de85
}

.editor>.container>.section>.list>div.selected {
  background: #f5c831;
  border: 1px solid #f5c831
}

.editor>.container>.section>.input {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 2px 0;
  padding: 4px 0;
  transition: all .2s
}

.editor>.container>.section>.header {
  margin-top: 10px;
  font-style: italic
}

.editor>.guideline {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: rgba(0, 0, 0, .3);
  opacity: 0;
  pointer-events: none;
  transition: all .3s;
  z-index: 101
}

.editor>.guideline.show {
  opacity: 1;
  pointer-events: auto
}

.editor>.guideline.show>.message {
  -webkit-transform: scale(1);
  transform: scale(1)
}

.editor>.guideline>.message {
  width: 500px;
  background: #fff;
  padding: 32px;
  border-radius: 2px;
  position: relative;
  -webkit-transform: scale(0);
  transform: scale(0);
  transition: all .3s
}

.editor>.guideline>.message>.header {
  font-size: 16px;
  font-weight: 700;
  padding: 0 0 12px
}

.editor>.guideline>.message>.sub-header {
  font-size: 13px;
  padding: 12px 0 4px;
  text-decoration: underline
}

.editor>.guideline>.message>.desc {
  font-size: 11px;
  padding: 0 0 12px 12px;
  margin-top: -4px;
  font-style: italic
}

.editor>.guideline>.message>div {
  padding: 12px 0
}

.editor>.guideline>.message>div>span {
  background: #ddd;
  padding: 2px 4px;
  border-radius: 2px;
  color: #e2252b
}

.editor>.guideline>.message>.close {
  color: #e2252b;
  font-size: 16px;
  position: absolute;
  top: 24px;
  right: 24px;
  padding: 8px;
  transition: all .2s;
  cursor: pointer
}

.editor>.guideline>.message>.close:hover {
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg)
}

.editor>.action {
  position: fixed;
  bottom: 48px;
  left: 50%;
  width: 100%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%)
}

.editor>.action,
.editor>.action>div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.editor>.action>div {
  width: 100px;
  padding: 8px 0;
  margin: 0 4px;
  border: 1px solid #666;
  color: #222;
  background: #fff;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: all .2s
}

.editor>.action>div:hover {
  background: #666;
  color: #fff
}

.editor>#highlight {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 100;
  pointer-events: none
}

.editor>#highlight>div {
  position: fixed;
  border: 1px solid hsla(0, 0%, 100%, .6)
}

.editor .dialog-content {
  position: relative
}

.editor .dialog-content>.dialog-export {
  width: 900px;
  height: 550px;
  font-size: 13px;
  line-height: 18px;
  overflow: hidden
}

.editor .dialog-content>.dialog-export>pre {
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden
}

.editor .dialog-content>.dialog-export>pre .string {
  color: #ff4500
}

.editor .dialog-content>.dialog-export>pre .number {
  color: #32cd32
}

.editor .dialog-content>.dialog-export>pre .boolean {
  color: blue
}

.editor .dialog-content>.dialog-export>pre .null {
  color: violet
}

.editor .dialog-content>.dialog-export>pre .key {
  color: #1e90ff
}

.scrollable[data-v-1eaa7b6c]::-webkit-scrollbar {
  width: 6px;
  height: 6px
}

.scrollable[data-v-1eaa7b6c]::-webkit-resizer {
  background: #f5c831
}

.scrollable[data-v-1eaa7b6c]::-webkit-scrollbar-track {
  background: #eee
}

.scrollable[data-v-1eaa7b6c]::-webkit-scrollbar-thumb {
  background: #666
}

.scrollable[data-v-1eaa7b6c]::-webkit-scrollbar-thumb:hover {
  background: #222
}

.reels-config[data-v-1eaa7b6c] {
  width: 100%;
  height: 700px;
  max-height: 85vh;
  max-width: 80vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap
}

.reels-config>.symbol-list[data-v-1eaa7b6c] {
  width: calc(100% - 320px);
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1
}

.reels-config>.symbol-list>.list[data-v-1eaa7b6c] {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  padding: 24px;
  position: relative;
  z-index: 1
}

.reels-config>.symbol-list>.list>.symbol[data-v-1eaa7b6c] {
  position: relative
}

.reels-config>.symbol-list>.list>.symbol>.element[data-v-1eaa7b6c] {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 4px;
  border-radius: 2px;
  white-space: nowrap;
  background: #f9de85;
  color: #222;
  z-index: 1
}

.reels-config>.symbol-list>.list>.symbol>.sprite[data-v-1eaa7b6c] {
  cursor: pointer;
  position: relative;
  transition: all .15s
}

.reels-config>.symbol-list>.list>.symbol>.sprite.symbol-selected[data-v-1eaa7b6c]:after,
.reels-config>.symbol-list>.list>.symbol>.sprite[data-v-1eaa7b6c]:hover:after {
  opacity: 1
}

.reels-config>.symbol-list>.list>.symbol>.sprite[data-v-1eaa7b6c]:after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  border: 1px solid #f5c831;
  opacity: 0;
  border-radius: 4px
}

.reels-config>.symbol-list>#context[data-v-1eaa7b6c] {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 2px;
  background: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .19), 0 6px 6px rgba(0, 0, 0, .23);
  overflow: hidden;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  -webkit-transform: scale(0);
  transform: scale(0);
  transition: opacity .1s, -webkit-transform .2s;
  transition: opacity .1s, transform .2s;
  transition: opacity .1s, transform .2s, -webkit-transform .2s
}

.reels-config>.symbol-list>#context.active[data-v-1eaa7b6c] {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  pointer-events: auto
}

.reels-config>.symbol-list>#context>div[data-v-1eaa7b6c] {
  padding: 10px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative
}

.reels-config>.symbol-list>#context>div[data-v-1eaa7b6c]:hover {
  background: hsla(0, 0%, 87%, .30000000000000004)
}

.reels-config>.symbol-list>#context>div>.mode[data-v-1eaa7b6c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-line-pack: center;
  align-content: center;
  border: 1px solid #666;
  border-radius: 2px;
  margin-left: 8px
}

.reels-config>.symbol-list>#context>div>.mode>div[data-v-1eaa7b6c] {
  padding: 2px 4px;
  transition: all .15s
}

.reels-config>.symbol-list>#context>div>.mode>div[data-v-1eaa7b6c]:first-child {
  border-right: 1px solid #666
}

.reels-config>.symbol-list>#context>div>.mode>div.selected[data-v-1eaa7b6c] {
  background: #f5c831
}

.reels-config>.config[data-v-1eaa7b6c] {
  width: 320px;
  height: 100%;
  padding-left: 8px;
  border-left: 1px solid #eee;
  position: relative;
  z-index: 2
}

.reels-config>.config>.symbol-config[data-v-1eaa7b6c] {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px;
  position: relative
}

.reels-config>.config>.symbol-config>.item[data-v-1eaa7b6c] {
  padding: 8px 6px;
  width: 100%;
  height: 84px;
  border-radius: 2px;
  border: 1px solid transparent;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow: hidden;
  z-index: 1;
  transition: border-color .2s
}

.reels-config>.config>.symbol-config>.item.ghost[data-v-1eaa7b6c] {
  opacity: .5
}

.reels-config>.config>.symbol-config>.item[data-v-1eaa7b6c]:hover {
  border-color: #f5c831
}

.reels-config>.config>.symbol-config>.item:hover>.act[data-v-1eaa7b6c] {
  opacity: 1;
  -webkit-transform: translateX(2px);
  transform: translateX(2px)
}

.reels-config>.config>.symbol-config>.item>.symbol[data-v-1eaa7b6c] {
  width: 68px;
  height: 68px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: 1px solid #f5c831;
  border-radius: 4px;
  overflow: hidden;
  position: relative
}

.reels-config>.config>.symbol-config>.item>.symbol>div[data-v-1eaa7b6c] {
  position: absolute
}

.reels-config>.config>.symbol-config>.item>.details[data-v-1eaa7b6c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-left: 16px;
  width: calc(100% - 88px);
  height: 100%
}

.reels-config>.config>.symbol-config>.item>.details>.text>div[data-v-1eaa7b6c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 2px
}

.reels-config>.config>.symbol-config>.item>.details>.text>div>.key[data-v-1eaa7b6c] {
  color: #222
}

.reels-config>.config>.symbol-config>.item>.details>.text>div>.value[data-v-1eaa7b6c] {
  background: #f9de85;
  color: #222;
  padding: 3px 6px;
  border-radius: 2px;
  margin-left: 8px;
  border: 0
}

.reels-config>.config>.symbol-config>.item>.details>.text>div>input.value[data-v-1eaa7b6c] {
  width: 24px;
  height: 18px;
  padding: 0;
  text-align: center
}

.reels-config>.config>.symbol-config>.item>.details>.tags[data-v-1eaa7b6c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.reels-config>.config>.symbol-config>.item>.details>.tags>.multilang[data-v-1eaa7b6c] {
  margin-right: 4px;
  border-radius: 2px;
  padding: 4px;
  color: #222;
  border: 1px solid #222;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: all .2s
}

.reels-config>.config>.symbol-config>.item>.details>.tags>.multilang[data-v-1eaa7b6c]:hover {
  opacity: .5
}

.reels-config>.config>.symbol-config>.item>.details>.tags>.multilang.active[data-v-1eaa7b6c] {
  border: 1px solid #e2252b;
  background: #e2252b;
  color: #fff
}

.reels-config>.config>.symbol-config>.item>.act[data-v-1eaa7b6c] {
  width: 24px;
  height: 84px;
  position: relative;
  -webkit-box-pack: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  color: #222;
  -webkit-transform: translateX(8px);
  transform: translateX(8px);
  opacity: 0
}

.reels-config>.config>.symbol-config>.item>.act>div[data-v-1eaa7b6c],
.reels-config>.config>.symbol-config>.item>.act[data-v-1eaa7b6c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  transition: all .2s
}

.reels-config>.config>.symbol-config>.item>.act>div[data-v-1eaa7b6c] {
  padding: 4px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #666;
  fill: #666
}

.reels-config>.config>.symbol-config>.item>.act>div[data-v-1eaa7b6c]:hover {
  fill: #000
}

.reels-config>.config>.symbol-config>.item>.act>.handle[data-v-1eaa7b6c] {
  cursor: -webkit-grab;
  cursor: grab
}

.reels-config>.config>.symbol-config>.item>.act>.cross[data-v-1eaa7b6c]:hover {
  fill: #e2252b
}

.reels-config>.config>.hint-sym[data-v-1eaa7b6c] {
  position: absolute;
  top: 50%;
  left: 0;
  width: 30px;
  height: 30px;
  -webkit-transform: translate(-50%, -50%) scaleX(-1);
  transform: translate(-50%, -50%) scaleX(-1);
  font-size: 32px;
  line-height: 28px;
  text-align: center;
  color: #f5c831;
  background: #fff;
  border: 1px solid #f5c831;
  border-radius: 2px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.advance-adjustment {
  width: 1200px;
  height: 700px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

.advance-adjustment>div:first-child {
  width: 400px;
  padding: 0 8px;
  overflow-x: hidden;
  overflow-y: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.advance-adjustment>div:first-child>div {
  max-width: 100%;
  border: 1px solid transparent;
  border-radius: 2px;
  transition: all .15s
}

.advance-adjustment>div:first-child>div:hover {
  border-color: #f5c831
}

.advance-adjustment>div:nth-child(2) {
  width: calc(100% - 624px);
  background: #eee;
  margin: 0 12px
}

.advance-adjustment>div:nth-child(3) {
  width: 300px
}

.advance-adjustment>div:nth-child(3)>div {
  width: 100%;
  height: 50%
}

.scrollable[data-v-62f43cbc]::-webkit-scrollbar {
  width: 6px;
  height: 6px
}

.scrollable[data-v-62f43cbc]::-webkit-resizer {
  background: #f5c831
}

.scrollable[data-v-62f43cbc]::-webkit-scrollbar-track {
  background: #eee
}

.scrollable[data-v-62f43cbc]::-webkit-scrollbar-thumb {
  background: #666
}

.scrollable[data-v-62f43cbc]::-webkit-scrollbar-thumb:hover {
  background: #222
}

.payline-visualizer>.visualizer[data-v-62f43cbc] {
  width: 640px;
  height: 450px;
  padding-left: 12px;
  overflow-y: auto;
  overflow-x: hidden
}

.payline-visualizer>.visualizer>.selection[data-v-62f43cbc] {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 16px
}

.payline-visualizer>.visualizer>.selection>.title[data-v-62f43cbc] {
  margin-right: 16px
}

.payline-visualizer>.visualizer>.selection>.box[data-v-62f43cbc] {
  padding: 6px 8px;
  border: 1px solid #ddd;
  background: #fff;
  color: #222;
  border-radius: 2px;
  margin: 4px 4px 4px 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
  transition: all .15s
}

.payline-visualizer>.visualizer>.selection>.box[data-v-62f43cbc]:hover {
  border-color: #222
}

.payline-visualizer>.visualizer>.selection>.box[data-v-62f43cbc]:active {
  background: #f9de85
}

.payline-visualizer>.visualizer>.selection>.box.active[data-v-62f43cbc] {
  border-color: #f5c831;
  background: #f5c831
}

.payline-visualizer>.visualizer>.selection>.box.unsaved[data-v-62f43cbc] {
  border-color: #e2252b
}

.payline-visualizer>.visualizer>.selection>.box.create[data-v-62f43cbc] {
  border-color: #f9de85;
  background: #f9de85
}

.payline-visualizer>.visualizer>.selection>.box.create[data-v-62f43cbc]:hover {
  border-color: #222;
  background: #f5c831
}

.payline-visualizer>.visualizer>.payline[data-v-62f43cbc] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  position: relative
}

.payline-visualizer>.visualizer>.payline>.line[data-v-62f43cbc] {
  margin: 8px 12px
}

.payline-visualizer>.visualizer>.payline>.line>.index[data-v-62f43cbc] {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  color: #222;
  margin-bottom: 2px;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%)
}

.payline-visualizer>.visualizer>.payline>.line>.payout-line-item[data-v-62f43cbc] {
  zoom: 200%;
  max-height: 40px !important
}

.payline-visualizer>.builder[data-v-62f43cbc] {
  width: 450px;
  height: 300px;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative
}

.payline-visualizer>.builder>.control[data-v-62f43cbc],
.payline-visualizer>.builder[data-v-62f43cbc] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.payline-visualizer>.builder>.control[data-v-62f43cbc] {
  width: 100%;
  height: 28px;
  margin-bottom: 12px
}

.payline-visualizer>.builder>.payline-list[data-v-62f43cbc] {
  width: 100px;
  height: calc(100% - 68px);
  border-right: 1px solid #f5c831;
  padding-right: 8px;
  overflow-y: auto;
  overflow-x: hidden
}

.payline-visualizer>.builder>.payline-list[data-v-62f43cbc]::-webkit-scrollbar {
  width: 3px
}

.payline-visualizer>.builder>.payline-list>.box[data-v-62f43cbc] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 8px;
  border: 1px solid transparent;
  position: relative;
  cursor: -webkit-grab;
  cursor: grab;
  transition: all .15s
}

.payline-visualizer>.builder>.payline-list>.box[data-v-62f43cbc]:hover {
  border: 1px solid #f5c831;
  border-radius: 2px
}

.payline-visualizer>.builder>.payline-list>.box:hover>.number[data-v-62f43cbc] {
  -webkit-transform: translateX(16px);
  transform: translateX(16px);
  opacity: 0
}

.payline-visualizer>.builder>.payline-list>.box:hover>.delete[data-v-62f43cbc] {
  -webkit-transform: translateX(8px);
  transform: translateX(8px);
  opacity: 1;
  pointer-events: auto
}

.payline-visualizer>.builder>.payline-list>.box>.number[data-v-62f43cbc] {
  margin-right: 12px;
  transition: all .15s
}

.payline-visualizer>.builder>.payline-list>.box>.delete[data-v-62f43cbc] {
  margin-left: -8px;
  opacity: 0;
  pointer-events: none;
  transition: all .15s;
  cursor: pointer
}

.payline-visualizer>.builder>.payline-list>.box>.delete[data-v-62f43cbc]:hover {
  color: #e2252b
}

.payline-visualizer>.builder>.payline-list>.box>.payout-line-item[data-v-62f43cbc] {
  zoom: 85%
}

.payline-visualizer>.builder>.payline-setup[data-v-62f43cbc] {
  width: calc(100% - 100px);
  height: calc(100% - 68px)
}

.payline-visualizer>.builder>.payline-setup>.act[data-v-62f43cbc] {
  height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.payline-visualizer>.builder>.payline-setup>.act>div[data-v-62f43cbc] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 4px;
  padding: 4px;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
  transition: all .15s
}

.payline-visualizer>.builder>.payline-setup>.act>div[data-v-62f43cbc]:hover {
  opacity: .75
}

.payline-visualizer>.builder>.payline-setup>.act>div[data-v-62f43cbc]:active {
  opacity: 1
}

.payline-visualizer>.builder>.payline-setup>.act>.add[data-v-62f43cbc] {
  background: #74cba8;
  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="filter"><feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0" /></filter></svg>#filter');
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  pointer-events: none
}

.payline-visualizer>.builder>.payline-setup>.act>.add.active[data-v-62f43cbc] {
  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="filter"><feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" /></filter></svg>#filter');
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
  pointer-events: auto
}

.payline-visualizer>.builder>.payline-setup>.act>.reset[data-v-62f43cbc] {
  background: #e2252b
}

.payline-visualizer>.builder>.payline-setup>.line-setup[data-v-62f43cbc] {
  width: 100%;
  height: calc(100% - 28px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column
}

.payline-visualizer>.builder>.payline-setup>.line-setup>.array[data-v-62f43cbc] {
  margin-top: 8px;
  margin-bottom: -12px
}

.payline-visualizer>.builder>.action[data-v-62f43cbc] {
  width: 100%;
  height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end
}

.payline-visualizer>.builder>.action>div[data-v-62f43cbc] {
  padding: 6px 8px;
  margin-left: 4px;
  background: #ddd;
  color: #222;
  cursor: pointer
}

.payline-visualizer>.builder>.action>div[data-v-62f43cbc]:hover {
  background: #666;
  color: #ddd
}

.scrollable[data-v-613826a4]::-webkit-scrollbar {
  width: 6px;
  height: 6px
}

.scrollable[data-v-613826a4]::-webkit-resizer {
  background: #f5c831
}

.scrollable[data-v-613826a4]::-webkit-scrollbar-track {
  background: #eee
}

.scrollable[data-v-613826a4]::-webkit-scrollbar-thumb {
  background: #666
}

.scrollable[data-v-613826a4]::-webkit-scrollbar-thumb:hover {
  background: #222
}

.snackbar[data-v-613826a4] {
  padding: 8px;
  background: #666;
  border-radius: 2px;
  position: absolute;
  opacity: 0;
  color: #fff;
  text-align: center;
  line-height: 14px;
  pointer-events: none;
  transition: opacity .15s, -webkit-transform .15s;
  transition: opacity .15s, transform .15s;
  transition: opacity .15s, transform .15s, -webkit-transform .15s
}

.snackbar.active[data-v-613826a4] {
  opacity: 1;
  pointer-events: auto
}

.snackbar.active[data-v-613826a4]:hover {
  opacity: .75
}

.snackbar[data-direction=top][data-v-613826a4] {
  top: 0;
  left: 50%;
  -webkit-transform: translate(-50%, -20px);
  transform: translate(-50%, -20px)
}

.snackbar[data-direction=top].active[data-v-613826a4] {
  -webkit-transform: translate(-50%);
  transform: translate(-50%)
}

.snackbar[data-direction=bottom][data-v-613826a4] {
  bottom: 0;
  left: 50%;
  -webkit-transform: translate(-50%, 20px);
  transform: translate(-50%, 20px)
}

.snackbar[data-direction=bottom].active[data-v-613826a4] {
  -webkit-transform: translate(-50%);
  transform: translate(-50%)
}

.snackbar[data-direction=left][data-v-613826a4] {
  left: 0;
  top: 50%;
  -webkit-transform: translate(-20px, -50%);
  transform: translate(-20px, -50%)
}

.snackbar[data-direction=left].active[data-v-613826a4] {
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%)
}

.snackbar[data-direction=right][data-v-613826a4] {
  right: 0;
  top: 50%;
  -webkit-transform: translate(20px, -50%);
  transform: translate(20px, -50%)
}

.snackbar[data-direction=right].active[data-v-613826a4] {
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%)
}

.snackbar[data-direction=topleft][data-v-613826a4] {
  top: 0;
  left: 0;
  -webkit-transform: translate(-20px);
  transform: translate(-20px)
}

.snackbar[data-direction=topleft].active[data-v-613826a4] {
  -webkit-transform: translate(0);
  transform: translate(0)
}

.snackbar[data-direction=topright][data-v-613826a4] {
  top: 0;
  right: 0;
  -webkit-transform: translate(20px);
  transform: translate(20px)
}

.snackbar[data-direction=topright].active[data-v-613826a4] {
  -webkit-transform: translate(0);
  transform: translate(0)
}

.snackbar[data-direction=bottomleft][data-v-613826a4] {
  bottom: 0;
  left: 0;
  -webkit-transform: translate(-20px);
  transform: translate(-20px)
}

.snackbar[data-direction=bottomleft].active[data-v-613826a4] {
  -webkit-transform: translate(0);
  transform: translate(0)
}

.snackbar[data-direction=bottomright][data-v-613826a4] {
  bottom: 0;
  right: 0;
  -webkit-transform: translate(20px);
  transform: translate(20px)
}

.snackbar[data-direction=bottomright].active[data-v-613826a4] {
  -webkit-transform: translate(0);
  transform: translate(0)
}

.dialog-popup {
  background: rgba(0, 0, 0, .2);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  padding: 12px;
  z-index: 102;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity .2s
}

.dialog-popup.show {
  opacity: 1;
  pointer-events: auto
}

.dialog-popup>.content {
  min-width: 320px;
  max-width: 100vw;
  max-height: 100vh;
  background: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .19), 0 6px 6px rgba(0, 0, 0, .23);
  border-radius: 4px;
  overflow: hidden
}

.dialog-popup>.content>.header {
  padding: 4px 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  background: #f5c831
}

.dialog-popup>.content>.header>.close {
  font-size: 16px;
  color: #fff;
  padding: 4px;
  cursor: pointer
}

.dialog-popup>.content>.dialog-body {
  padding: 12px;
  position: relative
}

.dialog-popup>.content>.dialog-body>.dialog-act {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin-top: 12px
}

.dialog-popup>.content>.dialog-body>.dialog-act>div {
  padding: 6px 8px;
  margin-left: 4px;
  background: #ddd;
  color: #222;
  cursor: pointer
}

.dialog-popup>.content>.dialog-body>.dialog-act>div:hover {
  background: #666;
  color: #ddd
}

.dialog-popup>.content>.dialog-body>.dialog-act>div.disabled {
  opacity: .6;
  pointer-events: none
}

.scrollable::-webkit-scrollbar {
  width: 6px;
  height: 6px
}

.scrollable::-webkit-resizer {
  background: #f5c831
}

.scrollable::-webkit-scrollbar-track {
  background: #eee
}

.scrollable::-webkit-scrollbar-thumb {
  background: #666
}

.scrollable::-webkit-scrollbar-thumb:hover {
  background: #222
}

.json-previewer {
  position: fixed;
  width: 360px;
  height: 440px;
  bottom: 0;
  right: 20px;
  z-index: 102;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  transition: width .3s, height .3s, -webkit-transform .3s;
  transition: transform .3s, width .3s, height .3s;
  transition: transform .3s, width .3s, height .3s, -webkit-transform .3s
}

.json-previewer.collapse {
  -webkit-transform: translateY(400px);
  transform: translateY(400px)
}

.json-previewer.fullscreen {
  width: 100vw;
  height: 100vh;
  bottom: 0;
  right: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end
}

.json-previewer.fullscreen>.tree {
  width: 50%
}

.json-previewer.fullscreen>.original-frame {
  left: 0
}

.json-previewer>.header {
  width: 100%;
  padding-left: 16px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background: #f5c831;
  color: #222;
  border-radius: 4px 4px 0 0;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.json-previewer>.header,
.json-previewer>.header>.action {
  height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.json-previewer>.header>.action {
  padding: 0 8px;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  cursor: default
}

.json-previewer>.header>.action>div {
  width: 24px;
  height: 24px;
  font-size: 14px;
  color: #222;
  fill: #222;
  border-radius: 2px;
  margin: 0 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: background .2s, -webkit-filter .2s;
  transition: background .2s, filter .2s;
  transition: background .2s, filter .2s, -webkit-filter .2s
}

.json-previewer>.header>.action>div>svg {
  pointer-events: none
}

.json-previewer>.header>.action>div[disabled=disabled] {
  opacity: .2;
  pointer-events: none
}

.json-previewer>.header>.action>div:hover {
  background: #f9de85
}

.json-previewer>.header>.action>div:active {
  background: #f5c831
}

.json-previewer>.tree {
  width: 100%;
  height: calc(100% - 40px);
  padding: 8px;
  background: #fff;
  border: 1px solid #ddd;
  border-width: 0 1px;
  overflow: auto;
  position: relative;
  z-index: 2
}

.json-previewer>.tree>.json-container {
  font-size: 15px;
  font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif
}

.json-previewer>.original-frame {
  position: absolute;
  top: 40px;
  left: -100%;
  border-width: 1px 0 0 1px;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  z-index: 1;
  transition: -webkit-transform .4s;
  transition: transform .4s;
  transition: transform .4s, -webkit-transform .4s
}

.json-previewer>.original-frame.show {
  -webkit-transform: translateX(0);
  transform: translateX(0)
}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
main,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
  display: block
}

body {
  line-height: 1
}

ol,
ul {
  list-style: none
}

blockquote,
q {
  quotes: none
}

blockquote:after,
blockquote:before,
q:after,
q:before {
  content: "";
  content: none
}

table {
  border-collapse: collapse;
  border-spacing: 0
}

* {
  box-sizing: border-box
}

body {
  font-family: PingFang, PingFangSC-Light, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif
}

#bet-detail {
  width: 415px;
  height: 736px;
  position: relative;
  margin: 0 auto;
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  background-color: #30303c;
  -webkit-transform: translateZ(0);
  transform: translateZ(0)
}

#bet-detail .result-title {
  margin-bottom: 10px
}

#bet-detail .result-title .result-title-container .result-title-detail .result-detail-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center
}

#bet-detail .payout .payout-item-container {
  height: 56px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

#bet-detail .payout .payout-item-container .payout-item-label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1
}

#bet-detail .payout .payout-item-container .payout-item-label .payout-item-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  line-height: 16px;
  letter-spacing: 0;
  margin-bottom: 2px;
  word-break: break-word
}

#bet-detail .payout .payout-item-container .payout-item-label .payout-item-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, .3);
  line-height: 12px;
  letter-spacing: 0;
  word-break: break-word
}

#bet-detail .payout .payout-item-container .payout-item-reward {
  padding-left: 4px
}

#bet-detail .payout .payout-item-container .payout-item-reward .payout-item-reward-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, .6);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: right;
  word-break: break-word
}

#bet-detail .payout .payout-item-container .payout-item-reward .payout-item-reward-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, .3);
  line-height: 12px;
  letter-spacing: 0;
  text-align: right;
  word-break: break-word
}

#bet-detail .payout .payout-item-container .payout-item-reward-icon {
  width: 48px;
  margin-right: 10px;
  text-align: center
}

#bet-detail .payout .payout-item-container .payout-item-reward-icon.empty {
  width: 0;
  margin-right: 0
}

#bet-detail .payout:last-child {
  margin-bottom: 28px
}

.bet-details {
  height: 672px;
  overflow-y: auto;
  position: relative
}

.bet-details .bet-result {
  margin-bottom: 20px
}

.content-wrapper {
  width: 360px;
  margin: 0 auto
}

.content-wrapper .payout-list .payout-list-content {
  padding: 0 20px;
  margin-bottom: 28px
}

.content-wrapper .payout-list .payout-list-header {
  padding: 0
}

.fade-enter-active {
  transition: all .3s ease
}

.fade-leave-active {
  transition: all .8s cubic-bezier(1, .5, .8, 1)
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

.slide-fade-enter-active {
  transition: all .3s ease
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1, .5, .8, 1)
}

.slide-fade-enter,
.slide-fade-leave-to {
  -webkit-transform: translateY(-15px);
  transform: translateY(-15px);
  opacity: 0
}

.ps:hover>.ps__scrollbar-y-rail:hover {
  background-color: transparent
}

.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail {
  background: #30303c !important
}

#bet-detail .bet-result-container {
  width: 300px;
  height: 275px;
  margin: 0 auto 20px;
  position: relative
}

#bet-detail .bet-result-container .reel-bar-container {
  position: absolute;
  top: 18px;
  left: 54px;
  height: 44px;
  width: 202px;
  margin: 0 auto;
  overflow: hidden
}

#bet-detail .bet-result-container .reel-bar-container .block {
  float: left;
  height: 46px;
  width: 54px;
  margin: 0 -2px;
  position: relative
}

#bet-detail .bet-result-container .reel-bar-container .block>* {
  position: absolute;
  top: 0;
  left: 0
}

#bet-detail .bet-result-container .reel-bar-container .block .glow-pattern {
  top: 0;
  left: -2px
}

#bet-detail .bet-result-container .reel-bar-container .block .glow.scatter_glow {
  z-index: 1;
  top: -14px;
  left: -16px
}

#bet-detail .bet-result-container .reel-bar-container .block .scatter_en,
#bet-detail .bet-result-container .reel-bar-container .block .scatter_zh,
#bet-detail .bet-result-container .reel-bar-container .block .wild_en_1x1,
#bet-detail .bet-result-container .reel-bar-container .block .wild_zh_1x1 {
  top: -10px;
  left: -5px;
  z-index: 1
}

#bet-detail .bet-result-container .reel-container-background {
  position: absolute;
  top: 10px;
  left: -2px;
  z-index: 6
}

#bet-detail .bet-result-container .reel-container {
  width: 300px;
  height: 220px;
  overflow: hidden;
  position: absolute;
  z-index: 2;
  top: 62px;
  margin-top: 0;
  margin-left: 3px
}

#bet-detail .bet-result-container .reel-container>* {
  position: absolute
}

#bet-detail .bet-result-container .reel-container .block {
  width: 54px;
  position: absolute;
  overflow: hidden
}

#bet-detail .bet-result-container .reel-container .block>* {
  position: absolute
}

#bet-detail .bet-result-container .reel-container .block.glow {
  overflow: unset
}

#bet-detail .bet-result-container .reel-container .block .symbol-reel {
  z-index: 3
}

#bet-detail .bet-result-container .reel-container .block .symbol-reel.scatter_b_en,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.scatter_b_zh,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.scatter_en,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.scatter_zh,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_en_1x1,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_en_1x2,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_en_1x3,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_en_1x4,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_zh_1x1,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_zh_1x2,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_zh_1x3,
#bet-detail .bet-result-container .reel-container .block .symbol-reel.wild_zh_1x4 {
  z-index: 6
}

#bet-detail .bet-result-container .reel-container .block .wild-size {
  position: absolute;
  z-index: 4;
  width: 100%;
  height: 32px;
  bottom: 2px
}

#bet-detail .bet-result-container .reel-container .block .wild-size.wild-size-2 {
  bottom: 2px
}

#bet-detail .bet-result-container .reel-container .block .wild-size.wild-size-3 {
  bottom: 4px
}

#bet-detail .bet-result-container .reel-container .block .wild-size.wild-size-4 {
  bottom: 7px
}

#bet-detail .bet-result-container .reel-container .block .background,
#bet-detail .bet-result-container .reel-container .block .base {
  z-index: 2;
  margin: 0
}

#bet-detail .bet-result-container .reel-container .block .frame {
  z-index: 5;
  margin: 0
}

#bet-detail .bet-result-container .reel-container .block .frame.gold_1,
#bet-detail .bet-result-container .reel-container .block .frame.gold_2,
#bet-detail .bet-result-container .reel-container .block .frame.gold_3,
#bet-detail .bet-result-container .reel-container .block .frame.gold_4 {
  z-index: 7
}

#bet-detail .bet-result-container .reel-container .block .olay {
  z-index: 4;
  mix-blend-mode: normal
}

#bet-detail .bet-result-container .reel-container .block .olay.bottom {
  bottom: 0
}

.sprite-symbol {
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(../../assets/resultGame/lucky-neko/sprites.d97d8ee.png)
}

.drum {
  width: 50px;
  height: 42px;
  background-position: 0 0
}

.drum_b {
  width: 50px;
  height: 84px;
  background-position: -490px -42px
}

.drum_block_1x1 {
  width: 50px;
  height: 42px;
  background-position: -50px 0
}

.drum_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -540px -42px
}

.drum_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -690px -126px
}

.drum_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -470px -252px
}

.f_sushi {
  width: 50px;
  height: 42px;
  background-position: -100px 0
}

.f_sushi_b {
  width: 50px;
  height: 84px;
  background-position: -590px -42px
}

.f_sushi_block_1x1 {
  width: 50px;
  height: 42px;
  background-position: -150px 0
}

.f_sushi_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -640px -42px
}

.f_sushi_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -740px -126px
}

.f_sushi_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -520px -252px
}

.fan {
  width: 50px;
  height: 42px;
  background-position: -200px 0
}

.fan_b {
  width: 50px;
  height: 84px;
  background-position: -690px -42px
}

.fan_block_1x1 {
  width: 50px;
  height: 42px;
  background-position: -250px 0
}

.fan_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -740px -42px
}

.fan_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -790px -126px
}

.fan_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -570px -252px
}

.l_10 {
  background-position: -300px 0
}

.l_10,
.l_10_block_1x1 {
  width: 50px;
  height: 42px
}

.l_10_block_1x1 {
  background-position: -350px 0
}

.l_10_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -790px -42px
}

.l_10_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -840px -126px
}

.l_10_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -620px -252px
}

.l_a {
  background-position: -400px 0
}

.l_a,
.l_a_block_1x1 {
  width: 50px;
  height: 42px
}

.l_a_block_1x1 {
  background-position: -450px 0
}

.l_a_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -840px -42px
}

.l_a_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -890px -126px
}

.l_a_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -670px -252px
}

.l_j {
  background-position: -500px 0
}

.l_j,
.l_j_block_1x1 {
  width: 50px;
  height: 42px
}

.l_j_block_1x1 {
  background-position: -550px 0
}

.l_j_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -890px -42px
}

.l_j_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -940px -126px
}

.l_j_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -720px -252px
}

.l_k {
  background-position: -600px 0
}

.l_k,
.l_k_block_1x1 {
  width: 50px;
  height: 42px
}

.l_k_block_1x1 {
  background-position: -650px 0
}

.l_k_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -940px -42px
}

.l_k_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: 0 -252px
}

.l_k_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -770px -252px
}

.l_q {
  background-position: -700px 0
}

.l_q,
.l_q_block_1x1 {
  width: 50px;
  height: 42px
}

.l_q_block_1x1 {
  background-position: -750px 0
}

.l_q_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: 0 -126px
}

.l_q_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -50px -252px
}

.l_q_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -820px -252px
}

.lantern {
  width: 50px;
  height: 42px;
  background-position: -800px 0
}

.lantern_b {
  width: 50px;
  height: 84px;
  background-position: -50px -126px
}

.lantern_block_1x1 {
  width: 50px;
  height: 42px;
  background-position: -850px 0
}

.lantern_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -100px -126px
}

.lantern_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -100px -252px
}

.lantern_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -870px -252px
}

.neko {
  width: 50px;
  height: 42px;
  background-position: -900px 0
}

.neko_b {
  width: 50px;
  height: 84px;
  background-position: -150px -126px
}

.neko_block_1x1 {
  width: 50px;
  height: 42px;
  background-position: 0 -42px
}

.neko_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -200px -126px
}

.neko_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -150px -252px
}

.neko_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -920px -252px
}

.reel_bg {
  background-position: -270px -420px
}

.reel_bg,
.reel_bonus_bg {
  width: 310px;
  height: 268px
}

.reel_bonus_bg {
  background-position: -580px -420px
}

.scatter_b_en {
  width: 60px;
  height: 92px;
  background-position: -450px -126px
}

.scatter_b_zh {
  width: 60px;
  height: 92px;
  background-position: -510px -126px
}

.scatter_en {
  width: 60px;
  height: 57px;
  background-position: -250px -42px
}

.scatter_zh {
  width: 60px;
  height: 57px;
  background-position: -310px -42px
}

.special_1x1_gold {
  width: 50px;
  height: 42px;
  background-position: -50px -42px
}

.special_1x1_silver {
  width: 50px;
  height: 42px;
  background-position: -100px -42px
}

.special_1x2_gold {
  width: 50px;
  height: 84px;
  background-position: -250px -126px
}

.special_1x2_silver {
  width: 50px;
  height: 84px;
  background-position: -300px -126px
}

.special_1x3_gold {
  width: 50px;
  height: 126px;
  background-position: -200px -252px
}

.special_1x3_silver {
  width: 50px;
  height: 126px;
  background-position: -250px -252px
}

.special_1x4_gold {
  width: 50px;
  height: 168px;
  background-position: 0 -420px
}

.special_1x4_silver {
  width: 50px;
  height: 168px;
  background-position: -50px -420px
}

.sushi {
  width: 50px;
  height: 42px;
  background-position: -150px -42px
}

.sushi_b {
  width: 50px;
  height: 84px;
  background-position: -350px -126px
}

.sushi_block_1x1 {
  width: 50px;
  height: 42px;
  background-position: -200px -42px
}

.sushi_block_1x2 {
  width: 50px;
  height: 84px;
  background-position: -400px -126px
}

.sushi_block_1x3 {
  width: 50px;
  height: 126px;
  background-position: -300px -252px
}

.sushi_block_1x4 {
  width: 50px;
  height: 168px;
  background-position: -100px -420px
}

.wild_en_1x1 {
  width: 60px;
  height: 57px;
  background-position: -370px -42px
}

.wild_en_1x2 {
  width: 60px;
  height: 92px;
  background-position: -570px -126px
}

.wild_en_1x3 {
  width: 60px;
  height: 135px;
  background-position: -350px -252px
}

.wild_en_1x4 {
  width: 60px;
  height: 180px;
  background-position: -150px -420px
}

.wild_zh_1x1 {
  width: 60px;
  height: 57px;
  background-position: -430px -42px
}

.wild_zh_1x2 {
  width: 60px;
  height: 92px;
  background-position: -630px -126px
}

.wild_zh_1x3 {
  width: 60px;
  height: 135px;
  background-position: -410px -252px
}

.wild_zh_1x4 {
  width: 60px;
  height: 180px;
  background-position: -210px -420px
}

.summary-header .header-item .header-item-desc {
  font-size: 10px;
  margin-bottom: 3px;
}

.summary-header .header-item .header-item-value {
  display: table-cell;
  vertical-align: middle;
  height: 28px;
}

.summary-header .header-item.header-balance .header-item-value {
  width: 91px;
  text-align: right;
}

.summary-header.old-mode .header-item.header-balance,
.summary-header.old-mode .header-item.header-balance .header-item-desc,
.summary-header.old-mode .header-item.header-balance .header-item-value {
  text-align: center;
}

.summary-header {
  background-color: #282832;
  height: 64px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 11px;
  line-height: 14px;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-top: 1px solid #30303c;
  border-bottom: 1px solid #30303c;
  padding: 0 5px;
}

.summary-header.old-mode .header-item {
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: center;
}

.summary-header .header-item .header-item-value[data-v-75420858] {
  display: table-cell;
  vertical-align: middle;
  height: 28px;
}

.summary-header .header-item {
  text-align: left;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding: 6px 5px;
}

.summary-header .header-item .header-item-value {
  display: table-cell;
  vertical-align: middle;
  height: 28px;
}

.bet-result-item {
  position: relative;
  height: 54px;
  margin: 0 32px;
  color: hsla(0, 0%, 100%, .6);
  font-size: 13px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-decoration: none;
  cursor: pointer;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  background-color: #282832;
  border-bottom: 1px solid hsla(0, 0%, 100%, .05);
}
</style>